module.exports = __webpack_public_path__ + "static/media/GalleryImage10.aabd6c60.jpg";